import { getRequest, postRequest, deleteRequest } from "app/axiosClient";
import {
  getPartsRecords,
  getNonStockItemRecords,
  getTargetEquipmentRecords,
  getVendorRecords,
  getAppointmentDetailsFromGI,
} from "./PartsSlice";
import {
  showLoader,
  hideLoader,
} from "../CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import OpenNotificationWithIcon from "common/utils/OpenNotificationWithIcon";
export const getAllPartsRecordsApi = (input) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Parts/GetPartsList`, input)
      .then((res) => {
        dispatch(getPartsRecords(res.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Parts.UnablePerformOperation"
        );
      });
  } catch (e) {
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Parts.UnablePerformOperation"
    );
    dispatch(hideLoader());
  }
};

export const addUpdatePartApi =
  (values, setPartEditMode, setClearFilter) => (dispatch) => {
    try {
      dispatch(showLoader());
      postRequest(`api/Parts/AddUpdateParts`, values)
        .then((res) => {
          var input = {
            appoinmentNbr: res.data,
            inventorysearch: null,
            descriptionsearch: null,
          };
          dispatch(getAllPartsRecordsApi(input));
          setPartEditMode(false);
          setClearFilter(false);
          if (values.id != null) {
            OpenNotificationWithIcon(
              "success",
              "Common.Success",
              "",
              "Parts.Partsuccessfullyupdated"
            );
          } else {
            OpenNotificationWithIcon(
              "success",
              "Common.Success",
              "",
              "Parts.PartSuccessfullyAddedAppointment"
            );
          }
        })
        .catch((e) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "Parts.UnablePerformOperation"
          );
        });
    } catch (e) {
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Parts.UnablePerformOperation"
      );
      dispatch(hideLoader());
    }
  };

export const deletePartApi = (payload, setClearFilter) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Parts/DeletePart`, payload)
      .then((res) => {
        var input = {
          appoinmentNbr: res.data,
          inventorysearch: null,
          descriptionsearch: null,
        };
        dispatch(getAllPartsRecordsApi(input));
        setClearFilter(false);
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Parts.SuccessfullyDeletedPart"
        );
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Parts.UnableDeletePart"
        );
      });
  } catch (e) {
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Parts.UnableDeletePart"
    );
    dispatch(hideLoader());
  }
};

export const getNonStockItemsApi = (type) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetNonStockItemsList?ItemType=${type}`)
      .then((res) => {
        dispatch(getNonStockItemRecords(res.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon("error", "Common.Error", "", "Parts.TryAgain");
      });
  } catch (e) {
    OpenNotificationWithIcon("error", "Common.Error", "", "Parts.TryAgain");
    dispatch(hideLoader());
  }
};

export const getTargetEquipmentsApi = (customerId, location) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(
      `api/Lookup/GetTargetEquipmentList?customerId=${customerId}&location=${location}`
    )
      .then((res) => {
        dispatch(getTargetEquipmentRecords(res.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon("error", "Common.Error", "", "Parts.TryAgain");
      });
  } catch (e) {
    OpenNotificationWithIcon("error", "Common.Error", "", "Parts.TryAgain");
    dispatch(hideLoader());
  }
};

export const getVendorListApi = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetVendorList`)
      .then((res) => {
        dispatch(getVendorRecords(res.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon("error", "Common.Error", "", "Parts.TryAgain");
      });
  } catch (e) {
    OpenNotificationWithIcon("error", "Common.Error", "", "Parts.TryAgain");
    dispatch(hideLoader());
  }
};

export const getPartCreatedScreenApi =
  (appointmentNbr, noteId) => (dispatch) => {
    try {
      dispatch(showLoader());
      postRequest(
        `api/Parts/GetPartsDetailsGI?appointmentNbr=${appointmentNbr}&noteId=${noteId}`
      )
        .then((res) => {
          dispatch(getAppointmentDetailsFromGI(res.data));
          dispatch(hideLoader());
        })
        .catch((e) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "Parts.TryAgain"
          );
        });
    } catch (e) {
      OpenNotificationWithIcon("error", "Common.Error", "", "Parts.TryAgain");
      dispatch(hideLoader());
    }
  };
